var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.variant === 'textarea' ? _c('BFormTextarea', {
    attrs: {
      "placeholder": _vm.$t(_vm.placeholder),
      "rows": _vm.rows,
      "disabled": _vm.disabled,
      "value": _vm.currentValue,
      "state": _vm.errors.length > 0 ? false : null
    },
    on: {
      "input": _vm.updateData
    }
  }) : _vm.variant === 'switch' ? _c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.disabled,
      "checked": _vm.currentValue,
      "switch": ""
    },
    on: {
      "input": _vm.updateData
    }
  }) : _c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t(_vm.placeholder),
      "disabled": _vm.disabled,
      "value": _vm.currentValue,
      "state": _vm.errors.length > 0 ? false : null
    },
    on: {
      "input": _vm.updateData
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }